import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "mqtt-ng-state-config"
  }, [_vm.targetFormat === 'ddr' ? [_vm._m(0)] : [_c('p', {
    staticClass: "card-description my-0"
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.mqtt.selectText')) + "\n    ")]), _c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": _vm.mode === 'readonly' || _vm.templateContext,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.mqtt.deviceIdentifier'),
      "autocomplete": "off",
      "hide-details": "auto"
    },
    model: {
      value: _vm.deviceIdentifier,
      callback: function ($$v) {
        _vm.deviceIdentifier = $$v;
      },
      expression: "deviceIdentifier"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": _vm.mode === 'readonly' || _vm.templateContext,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.mqtt.packetVariable'),
      "autocomplete": "off",
      "hide-details": "auto",
      "clearable": ""
    },
    model: {
      value: _vm.parsedPacketVariable,
      callback: function ($$v) {
        _vm.parsedPacketVariable = $$v;
      },
      expression: "parsedPacketVariable"
    }
  })], 1)], 1)]], 2);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('p', {
    staticClass: "card-description my-0"
  }, [_vm._v("\n      DDR routing is resolved via\n      "), _c('code', [_vm._v("ddr_dictionary")]), _vm._v("\n      . Use bridge config mapping fields to control identifier and variable extraction.\n    ")]);
}];
export { render, staticRenderFns };